import React from "react";
import ModuleFilterMenu from "./ModuleFilterMenu";
import ModuleRadioOption from "./ModuleRadioOption";

const DEFAULT_OPTIONS = [10, 20, 50];

const ModulePerPageMenu = ({
  open,
  onToggle,
  onClose,
  value,
  options = DEFAULT_OPTIONS,
  onChange,
}) => (
  <ModuleFilterMenu
    open={open}
    onToggle={onToggle}
    onClose={onClose}
    label={`${value} / page`}
    icon="ph:rows"
    eyebrow="Page size"
    title="Per page"
    columns={1}
    size="narrow"
    ariaLabel="Results per page"
  >
    <fieldset>
      <legend>Show</legend>
      {options.map((option) => (
        <ModuleRadioOption
          key={option}
          name="module-per-page"
          checked={value === option}
          onChange={() => onChange(option)}
          plain
        >
          {option} / page
        </ModuleRadioOption>
      ))}
    </fieldset>
  </ModuleFilterMenu>
);

export default ModulePerPageMenu;
